;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[{\"path\":\"/privacy\"},{\"path\":\"/terms\"},{\"path\":\"/\"},{\"path\":\"/about\"},{\"path\":\"/affiliates\"},{\"path\":\"/contact\"},{\"path\":\"/guide\"},{\"path\":\"/plans\"},{\"path\":\"/reseller\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.1.6";import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,

  sendDefaultPii: false,
  tracesSampleRate: 0.25,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
